// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1632833901130
      var cssReload = require("/builds/onefortysix/akkurat/website-legacy/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  